import { settlementEligibilityUrl } from "./endpoints.js";
const settlementEligibilityCacheKey = ({
  accountId,
  accountIdType
}) => [settlementEligibilityUrl, { accountId, accountIdType }];
export {
  settlementEligibilityCacheKey
};
//# sourceMappingURL=cacheKeys.js.map
